/* global axios */
import ApiClient from '../ApiClient';

class CaptainNativeSkills extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId, page = 1 } = {}) {
    return axios.get(`${this.url}/${assistantId}/native_skills`, {
      params: { page },
    });
  }

  show({ assistantId, id }) {
    return axios.get(`${this.url}/${assistantId}/native_skills/${id}`);
  }

  create({ assistantId, ...data } = {}) {
    return axios.post(`${this.url}/${assistantId}/native_skills`, {
      native_skill: data,
    });
  }

  update({ assistantId, id }, data = {}) {
    return axios.put(`${this.url}/${assistantId}/native_skills/${id}`, {
      native_skill: data,
    });
  }

  delete({ assistantId, id }) {
    return axios.delete(`${this.url}/${assistantId}/native_skills/${id}`);
  }

  reorder({ assistantId, skillIds }) {
    return axios.post(`${this.url}/${assistantId}/native_skills/reorder`, {
      skill_ids: skillIds,
    });
  }

  getOptions({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/native_skills/options`);
  }
}

export default new CaptainNativeSkills();
